import React, { ImgHTMLAttributes, useEffect, useState } from 'react';

export const LOADING_THUMBNAIL_URL = 'https://assets.artifactuprising.com/assets/images/misc/shine-loader.gif';

export interface AsyncImageProps extends ImgHTMLAttributes<unknown> {
  sourceLoader: () => Promise<string>;
}

export const AsyncImage = ({ sourceLoader, ...rest }: AsyncImageProps): React.JSX.Element => {
  const [source, setSource] = useState<string>(LOADING_THUMBNAIL_URL);

  useEffect(() => {
    (async () => {
      const src = await sourceLoader();
      setSource(src);
    })();
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <img src={source} alt={rest.alt} {...rest} />;
};
